<template>
  <CDialog v-model="isOpen" class="dialog--small">
    <header class="dialog-header align-items-start">
      <div class="flex-fill pdgr">
        <h1 class="h4 mrgv0">
          {{ $t('contacts.delete.title') }}
        </h1>

        <h2 v-if="contact" class="h5 text-alt mrgt--">
          {{ contact.first_name }} {{ contact.last_name }}
        </h2>
      </div>

      <Btn variant="icon" @click="isOpen = !isOpen">
        <Icon id="close" :scale="0.75" />
      </Btn>
    </header>

    <main class="dialog-body">
      {{ $t('contacts.delete.body') }}
    </main>

    <footer class="dialog-footer">
      <ListInline align="center" size="small">
        <li>
          <Btn
            data-cy="cancel-button"
            variant="outline"
            @click="isOpen = false"
          >
            {{ $t('common.cancel') }}
          </Btn>
        </li>

        <li>
          <Btn
            data-cy="confirm-delete-button"
            variant="danger"
            @click="deleteExternalUser"
          >
            <Loader v-if="loading" size="small" negative />
            <template v-else>
              {{ $t('common.delete') }}
            </template>
          </Btn>
        </li>
      </ListInline>
    </footer>
  </CDialog>
</template>

<script>
import eventBus from '@/eventBus';
import { deleteExternalUser } from '@/services/external-users';

import Loader from '@/components/ui/Loader';

export default {
  components: {
    Loader,
  },

  data() {
    return {
      isOpen: false,
      loading: false,
      contact: null,
    };
  },

  watch: {
    isOpen() {
      if (!this.isOpen) {
        this.contact = null;
      }
    },
  },

  mounted() {
    eventBus.$on('toggleContactDeleteDialog', this.handleToggle);
  },

  beforeDestroy() {
    eventBus.$off('toggleContactDeleteDialog', this.handleToggle);
  },

  methods: {
    handleToggle(contact) {
      if (contact) {
        this.contact = Object.assign({}, contact);
        this.isOpen = !this.isOpen;
      }
    },

    deleteExternalUser() {
      this.loading = true;

      deleteExternalUser(this.contact)
        .then(() => {
          this.isOpen = false;
          this.$emit('update');
        })
        .catch(error => {
          this.$notify({
            type: 'error',
            title: this.$t('common.error'),
            text: error.message || error,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
